import gsap from 'gsap';

export function initMobileMenu() {
    const triggers = document.querySelectorAll('.js-toggle-mobile-menu');
    const overlay = document.querySelector('.m-mobile-nav__overlay');
    const bottomBar = document.querySelector('.m-mobile-nav__bar');
    const links = document.querySelectorAll('.mobile-link');
    const closeBtn = document.querySelector('.m-mobile-nav__close');

    if (!overlay) return;

    let isOpen = false;

    // Timeline GSAP (en pause au début)
    const tl = gsap.timeline({ paused: true });

    tl
    // 1. Apparition du fond blanc
    .to(overlay, { 
        duration: 0.5, 
        autoAlpha: 1, 
        ease: "power3.inOut" 
    })
    // 2. Disparition de la barre orange (vers le bas)
    .to(bottomBar, {
        duration: 0.3,
        y: 100,
        ease: "power2.in",
    }, "<") // commence en même temps
    // 3. Apparition des liens en cascade
    .to(links, {
        duration: 0.5,
        opacity: 1,
        y: 0,
        stagger: 0.1,
        ease: "back.out(1.7)"
    }, "-=0.2")
    // 4. Apparition du bouton fermer (Pop effect)
    .from(closeBtn, {
        duration: 0.5,
        opacity: 1,
        y: 0,
        stagger: 0.1,
        ease: "back.out(1.7)"
    }, "-=0.4");

    // Gestion du click
    triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            
            if (!isOpen) {
                tl.play();
                document.body.style.overflow = 'hidden'; // Bloque le scroll
            } else {
                tl.reverse();
                document.body.style.overflow = ''; // Réactive le scroll
            }
            
            isOpen = !isOpen;
        });
    });
}

// Lancer la fonction au chargement
initMobileMenu();